<template>
  <div class="main">
    <!-- 导航栏 -->
    <header :class="{ 'scrolled': scrolled }">
      <div class="container">
        <div class="navbar">
          <div class="logo">
            <div class="logo-img">八</div>
            <div class="logo-text">八骏马网络科技</div>
          </div>
          <ul class="nav-links">
            <li>
              <a href="#" class="active">首页</a>
            </li>
            <li>
              <a href="#services" @click="scrollTo('services')">服务</a>
            </li>
            <li>
              <a href="#features" @click="scrollTo('features')">优势</a>
            </li>
            <li>
              <a href="#process" @click="scrollTo('process')">流程</a>
            </li>
            <li>
              <a href="#contact" @click="scrollTo('contact')">联系我们</a>
            </li>
          </ul>
          <button class="contact-btn">立即预约</button>
          <button class="mobile-menu-btn" @click="toggleMobileMenu">
            <i class="fas fa-bars"></i>
          </button>
        </div>
      </div>
    </header>

    <!-- 移动端导航菜单 -->
    <div class="mobile-nav" :class="{ 'active': mobileMenuOpen }">
      <ul class="mobile-nav-links">
        <li>
          <a href="#" @click="closeMobileMenu">首页</a>
        </li>
        <li>
          <a href="#services" @click="scrollTo('services')">服务</a>
        </li>
        <li>
          <a href="#features" @click="scrollTo('features')">优势</a>
        </li>
        <li>
          <a href="#process" @click="scrollTo('process')">流程</a>
        </li>
        <li>
          <a href="#contact" @click="scrollTo('contact')">联系我们</a>
        </li>
        <li>
          <button class="btn btn-primary" style="width: 80%; margin: 15px auto;">立即预约</button>
        </li>
      </ul>
    </div>

    <!-- Banner区域 -->
    <section class="banner">
      <div class="container">
        <h2>关爱长者出行，守护健康之路</h2>
        <p>八骏马科技专注为老年人提供安全、便捷的出行和就医陪护服务，让每一次出行都充满温暖与安心</p>
        <div class="cta-buttons">
          <button class="btn btn-primary" @click="scrollTo('services')">了解服务</button>
          <button class="btn btn-secondary" @click="scrollTo('contact')">立即预约</button>
        </div>
      </div>
    </section>

    <!-- 服务介绍 -->
    <section id="services" class="services">
      <div class="container">
        <div class="section-title">
          <h2>我们的服务</h2>
          <p>专为老年人设计的贴心出行与陪护服务，解决子女后顾之忧</p>
        </div>
        <div class="services-grid">
          <div class="service-card fade-in">
            <div class="service-icon">
              <i class="fas fa-taxi"></i>
            </div>
            <h3>长者出行打车</h3>
            <p>为老年人提供专属的出行服务，车辆配备专业适老设施，司机经过专业培训，耐心细致，确保每一位长者安全舒适抵达目的地。</p>
            <button class="btn btn-secondary">了解更多</button>
          </div>

          <div class="service-card fade-in">
            <div class="service-icon">
              <i class="fas fa-user-nurse"></i>
            </div>
            <h3>陪护就医服务</h3>
            <p>专业陪护人员全程陪同老人就医，协助挂号、问诊、取药等流程，记录医嘱，提供就医后的康复建议和健康管理服务。</p>
            <button class="btn btn-secondary">了解更多</button>
          </div>

          <div class="service-card fade-in">
            <div class="service-icon">
              <i class="fas fa-calendar-check"></i>
            </div>
            <h3>预约服务</h3>
            <p>便捷的在线预约系统，子女可为父母远程预约出行或陪护服务，实时查看服务进度，让关爱不受距离限制。</p>
            <button class="btn btn-secondary">立即预约</button>
          </div>
        </div>
      </div>
    </section>

    <!-- 特点优势 -->
    <section id="features" class="features">
      <div class="container">
        <div class="section-title">
          <h2>我们的优势</h2>
          <p>为何选择八骏马科技的服务</p>
        </div>
        <div class="features-grid">
          <div class="feature-card fade-in">
            <div class="feature-icon">
              <i class="fas fa-shield-alt"></i>
            </div>
            <h3>安全保障</h3>
            <p>所有司机和陪护人员均经过严格筛选和背景调查，车辆配备GPS定位和紧急呼叫系统，确保长者安全。</p>
          </div>

          <div class="feature-card fade-in">
            <div class="feature-icon">
              <i class="fas fa-graduation-cap"></i>
            </div>
            <h3>专业培训</h3>
            <p>服务人员均接受老年护理专业培训，掌握老年心理、急救知识及沟通技巧，提供有温度的陪伴。</p>
          </div>

          <div class="feature-card fade-in">
            <div class="feature-icon">
              <i class="fas fa-hand-holding-heart"></i>
            </div>
            <h3>贴心服务</h3>
            <p>车辆配备适老设施，提供上下车协助、轮椅服务等，全程贴心照顾，让长者出行无忧。</p>
          </div>

          <div class="feature-card fade-in">
            <div class="feature-icon">
              <i class="fas fa-mobile-alt"></i>
            </div>
            <h3>智能平台</h3>
            <p>专属APP和微信小程序，操作简单，子女可远程预约和查看服务进度，实时掌握父母行程。</p>
          </div>

          <div class="feature-card fade-in">
            <div class="feature-icon">
              <i class="fas fa-headset"></i>
            </div>
            <h3>24小时客服</h3>
            <p>全天候客服支持，随时解答疑问，处理紧急情况，为长者和家人提供及时帮助。</p>
          </div>

          <div class="feature-card fade-in">
            <div class="feature-icon">
              <i class="fas fa-handshake"></i>
            </div>
            <h3>家庭关怀</h3>
            <p>服务后提供详细报告，包括健康建议和注意事项，让子女更了解父母状况，共同守护健康。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 使用流程 -->
    <section id="process" class="process">
      <div class="container">
        <div class="section-title">
          <h2>服务流程</h2>
          <p>简单四步，轻松享受专业服务</p>
        </div>
        <div class="process-steps">
          <div class="step fade-in">
            <div class="step-number">1</div>
            <h3>在线预约</h3>
            <p>通过APP、微信或电话预约服务，选择时间和地点</p>
          </div>

          <div class="step fade-in">
            <div class="step-number">2</div>
            <h3>确认信息</h3>
            <p>客服人员联系确认服务细节和特殊需求</p>
          </div>

          <div class="step fade-in">
            <div class="step-number">3</div>
            <h3>享受服务</h3>
            <p>专业司机或陪护人员按时上门提供服务</p>
          </div>

          <div class="step fade-in">
            <div class="step-number">4</div>
            <h3>服务反馈</h3>
            <p>服务完成后获取详细报告，提供反馈建议</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系方式 -->
    <section id="contact" class="contact">
      <div class="container">
        <div class="contact-info">
          <h2>联系我们</h2>
          <p>有任何问题或需要预约服务，请随时联系我们，我们将竭诚为您服务</p>

          <div class="cta-buttons">
            <a href="tel:400-123-4567" class="btn btn-primary">400-123-4567</a>
          </div>

          <div class="contact-methods">
            <div class="contact-method fade-in">
              <i class="fas fa-phone-alt"></i>
              <p>客服热线</p>
              <p>400-123-4567</p>
            </div>

            <div class="contact-method fade-in">
              <i class="fas fa-envelope"></i>
              <p>电子邮箱</p>
              <p>service@bajunma.com</p>
            </div>

            <div class="contact-method fade-in">
              <i class="fas fa-map-marker-alt"></i>
              <p>公司地址</p>
              <p>北京市朝阳区科技园区88号</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 底部备案信息 -->
    <footer>
      <div class="container">
        <div class="footer-content">
          <div class="footer-links">
            <a href="#">关于我们</a>
            <a href="#">服务条款</a>
            <a href="#">隐私政策</a>
            <a href="#">加入我们</a>
            <a href="#">帮助中心</a>
          </div>
          <p class="copyright">
            <a href="https://beian.miit.gov.cn">浙ICP备2024097934号-5</a>
            <br />© 2023 八骏马网络科技有限公司 版权所有
          </p>
        </div>
      </div>
    </footer>

    <!-- 返回顶部按钮 -->
    <!-- <div class="scroll-top" :class="{ 'active': showScrollTop }" @click="scrollToTop">
      <i class="fas fa-arrow-up"></i>
    </div>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      scrolled: false,
      showScrollTop: false,
      mobileMenuOpen: false
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    // 初始化滚动监听
    this.handleScroll();
  },
  methods: {
    handleScroll() {
      // 检测滚动位置
      this.scrolled = window.scrollY > 50;
      this.showScrollTop = window.scrollY > 300;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    scrollTo(elementId) {
      const element = document.getElementById(elementId);
      if (element) {
        // 关闭移动菜单
        this.mobileMenuOpen = false;

        window.scrollTo({
          top: element.offsetTop - 80,
          behavior: "smooth"
        });
      }
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
<style>
:root {
  --primary: #3498db;
  --secondary: #2c3e50;
  --accent: #e74c3c;
  --light: #ecf0f1;
  --dark: #2c3e50;
  --text: #34495e;
  --gray: #95a5a6;
  --white: #ffffff;
  --shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.main {
  background-color: #f8f9fa;
  color: var(--text);
  line-height: 1.25;
  overflow-x: hidden;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 头部导航样式 */
header {
  background-color: var(--white);
  box-shadow: var(--shadow);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
  transition: all 0.3s ease;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
}

.logo {
  display: flex;
  align-items: center;
}

.logo-img {
  height: 50px;
  width: 50px;
  background: var(--primary);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  color: var(--white);
  font-size: 20px;
  font-weight: bold;
}

.logo-text {
  font-size: 24px;
  color: var(--secondary);
  font-weight: bold;
}

.nav-links {
  display: flex;
  list-style: none;
}

.nav-links li {
  margin-left: 30px;
}

.nav-links a {
  text-decoration: none;
  color: var(--text);
  font-weight: 500;
  transition: color 0.3s;
  position: relative;
  padding-bottom: 5px;
}

.nav-links a:hover,
.nav-links a.active {
  color: var(--primary);
}

.nav-links a:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: var(--primary);
  transition: width 0.3s;
}

.nav-links a:hover:after,
.nav-links a.active:after {
  width: 100%;
}

.contact-btn {
  background: var(--primary);
  color: var(--white);
  border: none;
  padding: 8px 20px;
  border-radius: 30px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 8px rgba(52, 152, 219, 0.3);
}

.contact-btn:hover {
  background: #2980b9;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(52, 152, 219, 0.4);
}

/* Banner区域 */
.banner {
  background: linear-gradient(135deg, #3498db, #2c3e50);
  color: var(--white);
  padding: 150px 0 100px;
  text-align: center;
  margin-top: 80px;
  position: relative;
  overflow: hidden;
}

.banner:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none"><path d="M0,0 L100,0 L100,100 Z" fill="rgba(255,255,255,0.1)" /></svg>');
  background-size: 100% 100%;
  opacity: 0.1;
}

.banner h2 {
  font-size: 40px;
  margin-bottom: 16px;
  position: relative;
  z-index: 2;
}

.banner p {
  font-size: 16px;
  max-width: 700px;
  margin: 0 auto 30px;
  position: relative;
  z-index: 2;
}

.cta-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  position: relative;
  z-index: 2;
}

.btn {
  padding: 12px 30px;
  border-radius: 30px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s;
  display: inline-block;
  border: none;
  cursor: pointer;
  font-size: 16px;
}

.btn-primary {
  background: var(--accent);
  color: var(--white);
  box-shadow: 0 4px 8px rgba(231, 76, 60, 0.3);
}

.btn-primary:hover {
  background: #c0392b;
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(231, 76, 60, 0.4);
}

.btn-secondary {
  background: transparent;
  border: 2px solid var(--white);
  color: var(--white);
}

.btn-secondary:hover {
  background: var(--white);
  color: var(--primary);
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

/* 服务介绍 */
.services {
  padding: 100px 0;
  background: var(--white);
}

.section-title {
  text-align: center;
  margin-bottom: 60px;
}

.section-title h2 {
  font-size: 24px;
  color: var(--secondary);
  margin-bottom: 15px;
  position: relative;
  display: inline-block;
}

.section-title h2:after {
  content: "";
  position: absolute;
  width: 60%;
  height: 3px;
  background: var(--primary);
  bottom: -10px;
  left: 20%;
  border-radius: 3px;
}

.section-title p {
  color: var(--gray);
  max-width: 700px;
  margin: 20px auto 0;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-top: 40px;
}

.service-card {
  background: var(--white);
  border-radius: 10px;
  overflow: hidden;
  box-shadow: var(--shadow);
  transition: all 0.3s;
  text-align: center;
  padding: 40px 30px;
  position: relative;
  border-top: 3px solid var(--primary);
}

.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.service-icon {
  font-size: 30px;
  color: var(--primary);
  margin-bottom: 20px;
  transition: all 0.3s;
}

.service-card:hover .service-icon {
  transform: scale(1.1);
}

.service-card h3 {
  font-size: 25px;
  margin-bottom: 15px;
  color: var(--secondary);
}

.service-card p {
  color: var(--gray);
  margin-bottom: 20px;
}
p {
  font-size: 18px;
}
/* 特点优势 */
.features {
  padding: 100px 0;
  background: #f8f9fa;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.feature-card {
  background: var(--white);
  border-radius: 10px;
  padding: 30px;
  box-shadow: var(--shadow);
  display: flex;
  flex-direction: column;
  transition: all 0.3s;
  border-left: 4px solid var(--primary);
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

.feature-icon {
  width: 60px;
  height: 60px;
  background: rgba(52, 152, 219, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  transition: all 0.3s;
}

.feature-card:hover .feature-icon {
  background: var(--primary);
}

.feature-card:hover .feature-icon i {
  color: var(--white);
}

.feature-icon i {
  font-size: 24px;
  color: var(--primary);
  transition: all 0.3s;
}

.feature-card h3 {
  font-size: 25px;
  margin-bottom: 15px;
  color: var(--secondary);
}

/* 使用流程 */
.process {
  padding: 100px 0;
  background: var(--white);
  position: relative;
  overflow: hidden;
}

.process:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none"><path d="M0,0 L100,0 L100,100 Z" fill="rgba(52, 152, 219, 0.05)" /></svg>');
  background-size: 100% 100%;
  opacity: 0.5;
  z-index: 1;
}

.process-steps {
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
  flex-wrap: wrap;
  position: relative;
  z-index: 2;
}

.step {
  text-align: center;
  flex: 1;
  min-width: 200px;
  position: relative;
  padding: 0 20px;
}

.step:not(:last-child):after {
  content: "";
  position: absolute;
  top: 40px;
  right: 0;
  height: 2px;
  width: 50%;
  background: var(--primary);
  z-index: 1;
}

.step-number {
  width: 80px;
  height: 80px;
  background: var(--primary);
  color: var(--white);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  margin: 0 auto 20px;
  position: relative;
  z-index: 2;
  transition: all 0.3s;
  box-shadow: 0 4px 8px rgba(52, 152, 219, 0.3);
}

.step:hover .step-number {
  transform: scale(1.1);
  background: var(--accent);
}

.step h3 {
  margin-bottom: 15px;
  color: var(--secondary);
}

/* 联系方式 */
.contact {
  padding: 100px 0;
  background: linear-gradient(135deg, #2c3e50, #3498db);
  color: var(--white);
  text-align: center;
  position: relative;
}

.contact:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none"><path d="M0,0 L100,0 L100,100 Z" fill="rgba(255,255,255,0.05)" /></svg>');
  background-size: 100% 100%;
  opacity: 0.2;
}

.contact-info {
  max-width: 600px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

.contact-info h2 {
  font-size: 25px;
  margin-bottom: 20px;
}

.contact-info p {
  font-size: 20px;
  margin-bottom: 30px;
}

.contact-methods {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 40px;
}

.contact-method {
  background: rgba(255, 255, 255, 0.1);
  padding: 25px 20px;
  border-radius: 10px;
  transition: all 0.3s;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.contact-method:hover {
  transform: translateY(-5px);
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.contact-method i {
  font-size: 25px;
  margin-bottom: 15px;
  color: var(--white);
}

.contact-method p {
  margin: 5px 0;
}

/* 底部备案信息 */
footer {
  background: var(--dark);
  color: var(--white);
  padding: 30px 0 20px;
  text-align: center;
}

.footer-content {
  max-width: 800px;
  margin: 0 auto;
}

.footer-links {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.footer-links a {
  color: #bbb;
  text-decoration: none;
  margin: 0 15px;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: var(--white);
}

.copyright {
  color: #777;
  font-size: 14px;
  margin-top: 20px;
  line-height: 1.6;
}
.copyright a {
  color: #777;
  text-decoration: none;
}

/* 移动端导航菜单 */
.mobile-menu-btn {
  display: none;
  background: transparent;
  border: none;
  color: var(--secondary);
  font-size: 22px;
  cursor: pointer;
}

.mobile-nav {
  position: fixed;
  top: 80px;
  left: 0;
  width: 100%;
  background: var(--white);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  z-index: 999;
  transform: translateY(-150%);
  transition: transform 0.4s ease;
  padding: 20px 0;
}

.mobile-nav.active {
  transform: translateY(0);
}

.mobile-nav-links {
  list-style: none;
}

.mobile-nav-links li {
  margin: 15px 0;
  text-align: center;
}

.mobile-nav-links a {
  text-decoration: none;
  color: var(--text);
  font-size: 18px;
  font-weight: 500;
  display: block;
  padding: 10px;
  transition: all 0.3s;
}

.mobile-nav-links a:hover {
  color: var(--primary);
  background: rgba(52, 152, 219, 0.1);
}

/* 响应式设计 */
@media (max-width: 992px) {
  .banner {
    padding: 120px 0 80px;
  }

  .banner h2 {
    font-size: 25px;
  }

  .section-title h2 {
    font-size: 22px;
  }

  .step:not(:last-child):after {
    width: 40%;
  }
}

@media (max-width: 768px) {
  .nav-links,
  .contact-btn {
    display: none;
  }

  .mobile-menu-btn {
    display: block;
  }

  .banner {
    padding: 100px 0 60px;
    margin-top: 70px;
  }

  .banner h2 {
    font-size: 22px;
  }

  .banner p {
    font-size: 16px;
  }

  .cta-buttons {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }

  .services-grid,
  .features-grid {
    grid-template-columns: 1fr;
  }

  .process-steps {
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }

  .step:not(:last-child):after {
    display: none;
  }

  .step {
    margin-bottom: 30px;
  }

  .contact-methods {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .logo-text {
    font-size: 21px;
  }

  .banner h2 {
    font-size: 24px;
  }

  .btn {
    padding: 10px 20px;
    font-size: 15px;
  }

  .section-title h2 {
    font-size: 24px;
  }

  .service-card,
  .feature-card {
    padding: 30px 20px;
  }

  .step-number {
    width: 70px;
    height: 70px;
    font-size: 24px;
  }
}

/* 动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.fade-in {
  animation: fadeIn 1s forwards;
}

.scroll-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 50px;
  height: 50px;
  background: var(--primary);
  color: var(--white);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s;
  z-index: 1000;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.scroll-top.active {
  opacity: 1;
  visibility: visible;
}

.scroll-top:hover {
  background: var(--accent);
  transform: translateY(-5px);
}
</style>